// extracted by mini-css-extract-plugin
module.exports = {"container":"Handover_container__2PWUU"};